
const LineData = (randomSeries) => {

    var exportVar = []

    var date = new Date();
    var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());


    for (let y = 0; y < randomSeries.length; y++) {
        exportVar.push(
            {
                datos: new Array(500).fill({}).map((e, i) => ([now_utc - (1000 * 60 * 60 * (randomSeries.length - i)), Math.random() + 5])),
                color: y % 2 == 0 ? '#1792e5' : 'red',
                name: randomSeries[y]
            }
        )
        //console.log('***')
    }


    //console.log(exportVar)
    return exportVar
}



export default LineData




